<template>
    <div class="__kfc_popup_overlay" ref="itself" @click="(e) => {
        e.target === itself && handleClose();
    }
        ">

        <div class="__kfc_popup_main_wrap wrap-roadmap">
            <div class="roadmap">
                <div class="header">
                    <div class="order-type">
                        <img v-if="orderType === 1" src="@/assets/icons/electricCarBlack.svg" alt="">
                        <img v-if="orderType === 2" src="@/assets/icons/pickupBlack.svg" alt="">
                        <span class="__kfc_r_2">
                            {{ orderType === 1 ? $t('selectDeliveryAddress') : $t('selectPickupAddress') }}</span>
                    </div>
                    <div @click="handleClose" class="close">
                        <img src="@/assets/icons/closeButton.svg" alt="">
                    </div>
                </div>
                <div class="roadmap-content">
                    <div class="content-top">
                        <!-- <search-address v-if="orderType === 1" :address="currentAddress"
                            classes="__kfc_orderType_select_dark" type="outlets" :key="currentAddress" /> -->
                        <select-address v-if="orderType === 1" :position="currPos" classes="__kfc_orderType_select_dark"
                            :key="currPos" :dragStart="dragStart" />
                        <select-store v-if="orderType === 2" :address="currentAddress" classes="__kfc_orderType_select_dark"
                            :key="currentAddress"></select-store>
                        <current-location :styles="{ background: '#F7F7F7' }" @getAddress="getCurrentAddress"
                            :label="$t('useMyLocation')" />
                    </div>
                    <div class="map">
                        <GMapMap class="gmap" :center="center" :zoom="zoom" :options="options" :draggable="false">
                            <GMapMarker v-for="(location, index) in nearestOutlets" :key="index"
                                :position="{ lat: parseFloat(location?.latitude), lng: parseFloat(location?.longitude) }"
                                :icon="markerImg" :title="location?.name_mn" @click="markerClick(location)">
                                <GMapInfoWindow :closeclick="true" @closeclick="() => { markerCloseClick(location) }"
                                    :opened="location.outletname === openedOutlet">
                                    <div class="__marker_pin">
                                        <div class="__marker_img">
                                            <img :src="cdn + location.img_url" alt="KFC mongolia" />
                                        </div>
                                        <div class="__kfc_r_8 __marker_desc">
                                            <span v-if="locale == 'mn'">{{ location.name_mn }}</span>
                                            <span v-else>{{ location.name_en }}</span>
                                        </div>
                                    </div>
                                </GMapInfoWindow>
                            </GMapMarker>
                            <GMapMarker :zIndex="99999" :key="currPos"
                                :position="{ lat: parseFloat(currPos.lat), lng: parseFloat(currPos.lng) }"
                                :icon="markerCurrentPos" title="" :draggable="true" @dragend="updateCoordinates">
                            </GMapMarker>
                        </GMapMap>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import configJson from '../config'
import { computed, inject, onMounted, onUnmounted, reactive, ref, watch } from 'vue';
import { useStore } from 'vuex';
import SearchAddress from '@/components/SearchAddress.vue';
import CurrentLocation from '@/components/CurrentLocation.vue';
import { useRouter } from 'vue-router';
import markerImg from '@/assets/icons/marker.svg'
import markerCurrentPos from '@/assets/icons/ph_map-pin-fill.svg'
import Req from '@/utils/Request';
import SelectStore from '@/components/SelectStore.vue'
import SelectAddress from './SelectAddress.vue';
import { useGtm } from '@gtm-support/vue-gtm';

export default {
    components: {
        SearchAddress,
        CurrentLocation,
        SelectStore,
        SelectAddress
    },
    setup (props, { emit }) {
        const store = useStore();
        const notify = inject('notify');
        const gtm = useGtm();
        const orderType = computed(() => store.getters['address/getOrderType']);
        const itself = ref(null);
        const locale = computed(() => store.getters.locale);
        const deliveryAddress = computed(() => store.getters['address/getDeliveryAddress']);
        const outletName = computed(() => store.getters['address/getActiveOutlet']);
        const currPos = ref({ lat: 47.91798232576924, lng: 106.91774932624921, error: false });
        const zoom = ref(13);
        const nearestOutlets = ref([]);
        const allOutlets = ref([]);
        const openedOutlet = ref(null);
        const currentAddress = ref(null);
        const dragStart = ref(false);
        const cdn = configJson.CLOUDFRONT_IMAGE_PATH;
        // const cdn = 'https://w0qrdmx5fg.execute-api.ap-southeast-1.amazonaws.com/prod/resize';
        const center = ref({ lat: 47.91798232576924, lng: 106.91774932624921 });
        const options = reactive({
            scrollwheel: true,
            streetViewControl: false,
            disableDefaultUI: false,
            mapTypeControl: false,
            minZoom: 10,
            maxZoom: 20,
            gestureHandling: 'greedy'// 'cooperative'//greedy
        });
        const orderTypeAddress = computed(() => orderType.value === 1 ? deliveryAddress.value : outletName.value)
        watch(orderTypeAddress, () => {
            if (orderType.value === 1) {
                getPodOutlet();
            } else if (orderType.value === 2) {
                // getNearestOutletDelivery();
            }
        })
        const handleClose = () => {
            itself.value.classList.add("unfade");
            setTimeout(() => {
                emit("handleClose");
            }, 300);
        };
        const getCurrentAddress = async (address) => {
            console.log(address,'lalaalla');
            
            currentAddress.value = address.bairnote;

            dragStart.value = true;

            currPos.value = {
                lat: parseFloat(address.location?.lat || address.address?.latitude),
                lng: parseFloat(address.location?.lng || address.address?.longitude),
            };

            center.value = {
                lat: parseFloat(address.location?.lat || address.address?.latitude),
                lng: parseFloat(address.location?.lng || address.address?.longitude),
            };

            if (orderType.value === 2) {
                getNearestOutlets();
                zoom.value = 16;
            } else {
                getPodOutlet();
            }            
        };

        const getOutlets = async () => {
            const { data: result } = await Req({ url: '/manager/getOutlets', hideSuccess: true })
            if (result.success) {
                nearestOutlets.value = result.result
                allOutlets.value = result.result
            }
        }
        const getNearestOutletDelivery = () => {
            const outlet = allOutlets.value.find(item => item.outletname === outletName.value)
            if (outlet) {
                nearestOutlets.value = [outlet]
            }
        }

        const getPodOutlet = async () => {
            if (
                deliveryAddress.value.latitude === ''
                || deliveryAddress.value.longitude === ''
                || !deliveryAddress.value.latitude
                || !deliveryAddress.value.longitude
            ) {
                notify.warning({
                    message: locale.value == 'mn' ? 'Байршилын мэдээлэл хоосон байна' : 'Not found geo',
                    position: 'top-left'
                });
                return;
            }
            getNearestOutletDelivery()
        }
        const getNearestOutlets = async () => {
            const { data: result } = await Req({
                url: '/outletes/nearOutlets', body: {
                    lat: currPos.value.lat,
                    long: currPos.value.lng,
                },
                hideSuccess: true,
            });
            if (result.success) {
                nearestOutlets.value = result.result
            }
        }
        const markerClick = (outlet) => {
            if (!outlet) return;
            openedOutlet.value = outlet.outletname
            center.value = {
                lat: parseFloat(outlet.latitude),
                lng: parseFloat(outlet.longitude),
            }
        }
        const markerCloseClick = (outlet) => {
            openedOutlet.value = null
        }
        const updateCoordinates = (location) => {
            currPos.value = {
                lat: location.latLng.lat(),
                lng: location.latLng.lng()
            }
            dragStart.value = true;
            gtm.trackEvent({
                event: 'move_pin',
            });
        }
        getOutlets();
        onMounted(() => {
            document.querySelector('body').classList.add('__kfc_overflow_hidden');
        });
        onUnmounted(() => {
            document.querySelector('body').classList.remove('__kfc_overflow_hidden');
        })

        return {
            itself,
            handleClose,
            orderType,
            locale,
            zoom,
            center,
            cdn,
            options,
            markerImg,
            openedOutlet,
            nearestOutlets,
            currentAddress,
            markerCurrentPos,
            currPos,
            dragStart,
            getCurrentAddress,
            markerCloseClick,
            markerClick,
            updateCoordinates
        }
    }
}
</script>

<style lang="scss" scoped>
.wrap-roadmap {
    padding: 60px;
    height: 100%;
    min-width: 60vw;

    @media (max-width: 767px) {
        padding: 24px;
        min-width: 90vw;
    }

    .roadmap {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        gap: 24px;

        .header {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .order-type {
                display: flex;
                gap: 16px;
                align-items: center;
            }
        }

        .roadmap-content {
            width: 100%;
            display: flex;
            flex-direction: column;
            gap: 24px;
            height: 100%;

            .content-top {
                display: flex;
                gap: 10px;

                &>* {
                    height: 52px;
                }

                @media (max-width: 767px) {
                    flex-direction: column;

                    .current-location,
                    .__kfc_orderType_select {
                        height: 52px;
                    }
                }

            }

            .map {
                width: 100%;
                height: 100%;

                .gmap {
                    width: 100%;
                    height: 100%;
                }
            }
        }
    }

    .__marker_pin {
        background: $redMain;
        padding: 8px;
        border-radius: 4px;
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: center;
        .__marker_img {
            height: 200px;

            img {
                width: 100%;
                height: 100%;
            }
        }

        .__marker_desc {
            text-align: center;

            span {
                color: $whiteMain;
            }
        }
    }
}
</style>